export enum EReportActions {
  DeleteReport = 'DeleteReport',
  SetReportVisibility = 'SetReportVisibility',
  EditReport = 'EditReport',
  AddSavedViews = 'AddSavedViews',
  DeleteSavedViews = 'DeleteSavedViews',
  EditSavedViews = 'EditSavedViews',
  FilterViews = 'FilterViews',
  Copy = 'Copy',
  View = 'View',
  Create = 'Create',
  ManageReportGrants = 'ManageReportGrants',
  ViewReportGrants = 'ViewReportGrants'
}
